import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { getDate } from '../../Vehicles/helpers';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';

import { COLOR_PRIMARY_1 } from '../../../vars';

import { selectConfig } from '../../Api/selectors';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './CardTransportOrderStatuses.module.css';
import cn from 'classnames';

import { TransportOrderStatusCard } from './CardTransportOrderStatus';
import { VehicleStatusLabel } from '../../Vehicles/components/VehicleStatusLabel';


const Container = styled.div`
  font-size: 12px;

  .cardHeader {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
      margin-right: 5px;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .link-wrap {
    cursor: pointer;
    &:hover {
      color: ${COLOR_PRIMARY_1};
    }
  }
`;

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class TransportOrderStatusesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get transportOrder() {
    return this.props.transportOrder;
  }

  checkbox(type, label) {
    return <CheckboxComponent label={label} checked={this.state[type] == '1'} />;
  }

  isShowPropertyCell(type) {
    if (this.props.transportOrder?.[type]) {
      return true;
    }
    return false;
  }

  windowOpen(url, name, specs) {
    if (!url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    return window.open(url);
  }

  rows(transporter) {
    let rows = ['type', 'status', 'transporterId'];

    if (this.props.transportOrder?.type === 'incoming') {
      rows.push('incoming_invoice_payment_status');
    }
    if (this.props.transportOrder?.type === 'outgoing') {
      rows.push('outgoing_invoice_payment_status');
    }
  


    return rows;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const transporter = this.props.transporter;
    const vehicle = this.transportOrder?.vehicle;
    

    return (
      <Card className="company-info-card info-card data">
        <Container className="cardHeader">
          <HBox className="align-items-center">
            <h2 className="card-title m-0">{this.lbl('transporter.info.data.statuses')}</h2>
          </HBox>

          <>
            {this.rows().map(property => {
              if (property == 'type') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`transport_order.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                          <VehicleStatusLabel key={`${this.transportOrder?.id}-${this.transportOrder?.id}`} status={this.transportOrder?.[property]}>
                  {this.lbl('transport_order.filter.' + this.transportOrder?.[property])}
                </VehicleStatusLabel>
                            {/* {this.lbl(`transport_order.property.${this.transportOrder?.[property]}`)} */}
                          </div>
                        </div>
                      </div>
                    </>
                  )
                );
              }
              if (property == 'status') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`transport_order.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {/* <VehicleStatusLabel>{this.transportOrder?.[property]}</VehicleStatusLabel> */}
                            <VehicleStatusLabel key={`${this.transportOrder?.[property].id}`} status={this.transportOrder?.[property]}>
                  {this.lbl('transport_order.filter.' + this.transportOrder?.[property])}
                </VehicleStatusLabel>
                            {/* <TransportOrderStatusCard
                              style={{ minWidth: '100%' }}
                              // setStatusLogs={'true'}
                              // loggedInUserId={this.props.loggedInUserId}
                              transportOrder={this.transportOrder}
                            /> */}
                          </div>
                        </div>
                      </div>
                    </>
                  )
                );
              }

              if (property == 'transporterId') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`transport_order.overview.column.transporter`)}</div>
                          <div className={styles.labelTable}>
                            {transporter.name && transporter?.name}{transporter?.surname}
                          </div>
                        </div>
                      </div>

                      <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`vehicle.property.dateDone`)}</div>
                        <div className={styles.labelTable}>
                          {getDate(this.transportOrder?.dateDone)}
                        </div>
                      </div>
                    </div>
                    
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`transport_order.overview.column.datePlanned`)}</div>
                        <div className={styles.labelTable}>
                          {getDate(this.transportOrder?.datePlanned)}
                        </div>
                      </div>
                    </div>

                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`transport_order.overview.column.dateToPlan`)}</div>
                        <div className={styles.labelTable}>
                          {getDate(this.transportOrder?.dateToPlan)}
                        </div>
                      </div>
                    </div>

                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`vehicle.property.remarks`)}</div>
                        <div className={styles.labelTable}>
                          {this.transportOrder?.remarks}
                        </div>
                      </div>
                    </div>


                  </>
                  )
                );
              }



              if (property == 'incoming_invoice_payment_status' || property == 'outgoing_invoice_payment_status') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                      <div className={styles.labelTable}>
                        {property === 'incoming_invoice_payment_status' && (
                          <VehicleStatusLabel color={vehicle?.incoming_invoice_payment_status ? '#15AC79' : 'red'}>
                            {vehicle?.incoming_invoice_payment_status ? 'betaald' : 'Niet betaald'}
                          </VehicleStatusLabel>
                        )}
                        {property === 'outgoing_invoice_payment_status' && (
                          <VehicleStatusLabel
                            color={
                              vehicle?.outgoing_invoice_payment_status === 'PAID'
                                ? '#15AC79'
                                : vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID'
                                ? 'black'
                                : 'red'
                            }
                          >
                            {vehicle?.outgoing_invoice_payment_status === 'PAID'
                              ? 'Betaald'
                              : vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID'
                              ? 'Gedeeltelijk betaald'
                              : 'Niet betaald'}
                          </VehicleStatusLabel>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }

              if (property == 'email') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                        <div className={styles.labelTable}>{transporter?.[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              return (
                this.isShowPropertyCell(property) && (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                      <div className={styles.labelTable}>
                        {this.lbl(`transporter.property.${property}.${transporter?.[property]}`)}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </>
        </Container>
      </Card>
    );
  }
}

TransportOrderStatusesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderStatusesCard = compose(withConnect, withRouter)(TransportOrderStatusesCardComp);
